import React, {useState} from 'react';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {toast} from '../../constants';
import {ShowToastPayloadMap} from '../../redux/actions/toast.actions';
import AutoDismissWrapper from './AutoDismissWrapper';
import ToastItem from './ToastItem';

import styles from './Toast.pcss';

interface Props {
    dismissToastItem: (id: number) => void;
    toasts: ShowToastPayloadMap[];
}

interface ToastStyle {
    entering: any;
    entered: any;
    exiting: any;
}

type ToastStyles = Record<any, ToastStyle>;

interface RemoveStylesProps {
    setToastStyles: (styles: ToastStyles) => void;
    toastStyles: ToastStyles;
    node: Element;
}

interface SetStylesProps extends RemoveStylesProps {
    id: number;
}

const setStyles = ({id, setToastStyles, toastStyles, node}: SetStylesProps): void => {
    const animating = {marginTop: node.clientHeight * -1};
    const stopped = {marginTop: 0};
    setToastStyles({
        ...toastStyles,
        [id]: {
            entering: animating,
            entered: stopped,
            exiting: animating
        }
    });
};

const removeStyles = ({setToastStyles, toastStyles, node}: RemoveStylesProps): void => {
    const toastId: any = node.getAttribute('data-id');
    const {[toastId]: styleToRemove, ...remainingStyles} = toastStyles; //eslint-disable-line no-unused-vars, @typescript-eslint/no-unused-vars
    setToastStyles(remainingStyles);
};

const Toast = ({dismissToastItem, toasts}: Props) => {
    const [toastStyles, setToastStyles] = useState<ToastStyles>({});

    return (
        <div className={styles.wrapper}>
            <TransitionGroup component={null}>
                {toasts.map(content => {
                    const id = content.get('id');

                    return (
                        <CSSTransition
                            classNames={{
                                enterDone: styles.toastEnterDone,
                                exit: styles.toastExit
                            }}
                            key={id}
                            onEnter={node =>
                                setStyles({
                                    id,
                                    setToastStyles,
                                    toastStyles,
                                    node
                                })
                            }
                            onExited={node =>
                                removeStyles({
                                    setToastStyles,
                                    toastStyles,
                                    node
                                })
                            }
                            timeout={toast.ANIMATION_TIME}
                            unmountOnExit>
                            {CSSTransitionState => (
                                <AutoDismissWrapper
                                    className={styles.toast}
                                    dismissToastItem={dismissToastItem}
                                    id={id}
                                    style={toastStyles[id] && toastStyles[id][CSSTransitionState]}>
                                    <ToastItem
                                        content={content}
                                        dismissToastItem={dismissToastItem}
                                        id={id}
                                    />
                                </AutoDismissWrapper>
                            )}
                        </CSSTransition>
                    );
                })}
            </TransitionGroup>
        </div>
    );
};

export default Toast;
